module.exports = __webpack_public_path__ + "img/img11.0fd90e3e.png";